import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router';
import { PREVIEW_MODE_PARAM } from '../../utils/preview-mode-utils';

export enum PreviewQueryKey {
    SSR_PREVIEW_MODE = 'ssr-preview-mode',
}

/**
 * This hook is used to get the preview mode from the URL search params on the server side.
 * The data stays hydrated on the client side.
 */
export const useSSRPreviewMode = (): boolean => {
    const location = useLocation();
    const isPreviewMode = useMemo(
        () => Boolean(new URLSearchParams(location.search).get(PREVIEW_MODE_PARAM)),
        [location.search],
    );
    const queryResult = useQuery<boolean>({
        queryKey: [PreviewQueryKey.SSR_PREVIEW_MODE],
        initialData: isPreviewMode,
        queryFn: (): boolean => isPreviewMode,
        // Only run on the server side, but the data stays hydrated on the client side
        enabled: typeof window === 'undefined',
    });
    return queryResult.data;
};
